export interface ISalesChannelActiveness {
  web: boolean;
  mobile: boolean;
  shopilink: boolean;
}
